// extracted by mini-css-extract-plugin
export default {"filterBox":"styles_filterBox__XVzvn","icon":"styles_icon__oE3of"};